import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DistrictMaintenanceComponent } from './district-maintenance.component';

const routes: Routes = [
  {
    path:'',
    component: DistrictMaintenanceComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DistrictMaintenanceRoutingModule { }
